import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '@ion/iam';

/**
 * Guard that prevents access when the user is authenticated.
 * This is typically used for login/sign-in pages where authenticated users shouldn't have access.
 * If the user is authenticated, they will be redirected to the root page.
 */
export const isNotAuthenticatedGuard = async (): Promise<boolean | UrlTree> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);

  if (await authService.isSignedIn()) {
    return router.createUrlTree(['/']);
  }

  return true;
};
